import "./index.css";

function CopyrightFooter() {
	return (
		<footer id='copy-footer' className="ubuntu-font">
			&copy; Êxodo Jaffar, Henrique Claranhan
		</footer>
	);
}

export default CopyrightFooter;